import { render, staticRenderFns } from "./NotificationRuleDeleteModal.vue?vue&type=template&id=05cb54cb"
import script from "./NotificationRuleDeleteModal.vue?vue&type=script&lang=ts"
export * from "./NotificationRuleDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports